"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNationalReferentialCsv = void 0;
const routes_1 = require("../../routes");
const getNationalReferentialCsv = (client) => async (params) => {
    const response = await client.post(routes_1.ENDPOINTS.GET_PRODUCTS.path, { distributor_id: String(params.distributorId) }, {
        headers: {
            Accept: 'text/csv',
        },
    });
    return response;
};
exports.getNationalReferentialCsv = getNationalReferentialCsv;
